/**
 * Copies text to the user's clipboard using the Native Clipboard API.
 * @param {string} text - The text string to copy.
 * @param {Object} [options] - Configuration options.
 * @param {number} [options.timeout=2000] - Duration in ms for the status callback.
 * @param {Function} [options.onStatusChange] - Callback that receives true then false after timeout.
 * @returns {Promise<boolean>} Resolves to true if successful, false if failed.
 */
export async function copyToClipboard(text, options = {}) {
  const { timeout = 2000, onStatusChange } = options;

  if (!navigator?.clipboard) {
    console.error('Clipboard API is not supported in this browser environment.');
    return false;
  }

  try {
    await navigator.clipboard.writeText(text);
    
    // If a status callback is provided, trigger the success cycle
    if (typeof onStatusChange === 'function') {
      onStatusChange(true);
      setTimeout(() => {
        onStatusChange(false);
      }, timeout);
    }
    
    return true;
  } catch (error) {
    console.error('Failed to copy text to clipboard:', error);
    return false;
  }
}
